var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.624,
    height: 32.624,
    viewBox: "0 0 32.624 32.624",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-profile",
    transform: "translate(-1191.247 -796.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M1207.559,802.076a6.1,6.1,0,0,0-.035,12.2h.035a6.1,6.1,0,1,0,0-12.2Zm-4.3,6.07a4.3,4.3,0,0,1,4.3-4.3h0a4.3,4.3,0,1,1,0,8.6h0A4.306,4.306,0,0,1,1203.257,808.146Zm4.3,5.884Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M1207.559,796.877a16.312,16.312,0,1,0,16.312,16.312A16.33,16.33,0,0,0,1207.559,796.877Zm10.13,19.525a5.838,5.838,0,0,0-4.146-1.744h-1.726a.894.894,0,0,0-.576.217l-.328.263a5.274,5.274,0,0,1-6.771,0l-.316-.253a.9.9,0,0,0-.588-.224h-1.63a5.881,5.881,0,0,0-5.874,5.875v1.061a14.508,14.508,0,0,1,11.824-22.921h0a14.494,14.494,0,0,1,11.826,22.905v-1.013A5.834,5.834,0,0,0,1217.689,816.4Zm-20.154,4.16a4.077,4.077,0,0,1,4.041-4.1h1.415l.055.042a7.074,7.074,0,0,0,9.058.006l.062-.048h1.376a4.078,4.078,0,0,1,4.043,4.106v3.1a14.462,14.462,0,0,1-20.05.013Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user-profile.c833dab4d4961327f57d333df2d47022.svg";
export { ForwardRef as ReactComponent };